const navItems = [
    { name: 'Start', href: 'home' },
    { name: 'O Kancelarii', href: 'about' },
    { name: 'Usługi', href: 'services' },
    { name: 'Kontakt', href: 'contact' },
];

export default navItems;
